import React, {useEffect, useState} from 'react'
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import Dialog from '@material-ui/core/Dialog';
import CircularProgress from '@material-ui/core/CircularProgress';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';

export const Loader = ({title, text, log}) => {

    const [logText, setLogText] = useState('');

    useEffect(() => {

        if (log.show) {
            if (log.reset) {
                setLogText(log.text);
            }
            else {
                setLogText(`${logText} \n ${log.text}`);
            }
        }

    }, [log]);

    return (
        <div>
            <Dialog
                maxWidth="xs"
                aria-labelledby="confirmation-dialog-title"
                open={true}
                style={{zIndex: 13000}}
            >
                <DialogTitle id="confirmation-dialog-title">{title}</DialogTitle>
                <DialogContent dividers>
                    <Box position="relative" display="block" textAlign="center" alignItems="center" justifyContent="center">
                        <CircularProgress />
                    </Box>
                    <Box position="relative" display="block">
                        <Typography variant="body1" component="div" color="initial">
                            {text}
                        </Typography>
                    </Box>
                    <Box position="relative" display="block">
                        <Typography variant="caption" component="div" color="textSecondary">
                            {logText}
                        </Typography>
                    </Box>
                </DialogContent>
            </Dialog>
        </div>
    );
}